import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-link\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M4 4h24v24H4z\" /><g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"><path d=\"M14 18a3.502 3.502 0 0 0 5 0l4-4a3.535 3.535 0 1 0-5-5l-.5.5\" /><path d=\"M18 14a3.502 3.502 0 0 0-5-.001l-4 4a3.535 3.535 0 1 0 5 5l.5-.5\" /></g><rect width=\"32\" height=\"32\" rx=\"4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol